/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_A_No_RegistrationInputs */



/**
* | output |
* | --- |
* | "Yes. You can keep the tournament in Planned state, add players manually, check them all in, and start rounds. This works for small impromptu events." |
*
* @param {Og_Faq_A_No_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_a_no_registration = /** @type {((inputs?: Og_Faq_A_No_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_A_No_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui. Vous pouvez laisser le tournoi en état Planifié, ajouter les joueurs manuellement, tous les pointer, et démarrer les rondes. Cela convient aux petits événements improvisés.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí. Puedes dejar el torneo en estado Planificado, añadir jugadores manualmente, hacerles el check-in a todos y empezar las rondas. Esto sirve para eventos pequeños e improvisados.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sim. Você pode manter o torneio no estado Planejado, adicionar jogadores manualmente, fazer o check-in de todos e iniciar as rodadas. Isso funciona para eventos pequenos e improvisados.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì. Puoi lasciare il torneo in stato Pianificato, aggiungere i giocatori manualmente, fare il check-in di tutti e avviare i round. Va bene per piccoli eventi improvvisati.")
	return /** @type {LocalizedString} */ ("Yes. You can keep the tournament in Planned state, add players manually, check them all in, and start rounds. This works for small impromptu events.")
});